import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function BannerCarousel() {
  const [i, setI] = useState(0);
  const {data:banners=[]} = useQuery({
    queryKey:["public-banners"],
    queryFn:({signal})=>api.get("/banners",{signal,params:{active_only:true}}).then(r=>r.data),
    staleTime:60000,
    retry:1
  });
  if (!banners.length) return null;
  const b = banners[i % banners.length];
  return <section className="m20-container py-6 sm:py-8" data-testid="banner-carousel" aria-label="Destaques da loja">
    <div className="relative rounded-2xl overflow-hidden bg-foreground text-white">
      <img src={b.image_url} alt="" loading="lazy" decoding="async" width="1200" height="400" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground/95 to-foreground/60" />
      <div className="relative p-6 sm:p-10 lg:p-12 min-h-64 flex flex-col justify-center">
        <p className="text-xs uppercase tracking-widest text-secondary font-semibold mb-3">Em destaque</p>
        <h2 className="font-display font-bold text-3xl sm:text-5xl leading-tight max-w-2xl">{b.title}</h2>
        {b.subtitle && <p className="mt-4 text-sm sm:text-base text-white/90 max-w-xl">{b.subtitle}</p>}
        {banners.length > 1 && <div className="flex items-center gap-3 mt-6">
          <button onClick={() => setI((i - 1 + banners.length) % banners.length)} className="w-11 h-11 grid place-items-center rounded-full border border-white/40 hover:bg-white/20" aria-label="Destaque anterior"><ChevronLeft size={20}/></button>
          <span className="text-sm tabular-nums" aria-live="polite">{i + 1} / {banners.length}</span>
          <button onClick={() => setI((i + 1) % banners.length)} className="w-11 h-11 grid place-items-center rounded-full border border-white/40 hover:bg-white/20" aria-label="Próximo destaque"><ChevronRight size={20}/></button>
        </div>}
      </div>
    </div>
  </section>;
}
